import { render, staticRenderFns } from "./SignupDetail.vue?vue&type=template&id=0b640a4f&"
import script from "./SignupDetail.vue?vue&type=script&lang=js&"
export * from "./SignupDetail.vue?vue&type=script&lang=js&"
import style0 from "./SignupDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports